/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-script-url */
/* eslint-disable max-len */
import React, { Component } from 'react';
import SocialBlock from '@js/components/SocialBlock/index';

class FooterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleNavClick = (e) => {
    e.preventDefault();
  };

  render() {
    const { socialBlockType } = this.props;
    return (
      // eslint-disable-next-line react/jsx-filename-extension
      <>
        <footer id="footer__content">
          {socialBlockType && <SocialBlock socialBlockType={socialBlockType} />}
          <nav className="navbar navbar-expand-lg navbar-light navbar-footer bg-white d-flex justify-content-between align-items-center py-0">
            <div className="container navbar__navbar-footer-container">
              <div className="row justify-content-center">
                {/* logo */}
                <a
                  href="/"
                  className="navbar-brand navbar__brand-footer d-flex align-items-center justify-content-center col-12 col-lg-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="215.413"
                    height="65.027"
                    viewBox="0 0 215.413 65.027"
                  >
                    <g transform="translate(-1265.915 -844.592)">
                      <path
                        d="M80.23,61.827H75.915V0l3.672,3.607c.328.323,33.658,32.231,106.694,30.607h.057c7.547,0,71.583-.875,101.318-30.191L291.328.4V45.01h-4.315V10.448c-32.179,27.228-93.2,28.083-100.622,28.083h-.064C124.406,39.909,90.812,18.2,80.23,9.842Z"
                        transform="translate(1190 844.591)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M235.238,84.75v-.933l5.993-7.412h-5.757v-.881h7.206v.829l-6.044,7.515h6.044v.881Z"
                        transform="translate(1142.216 821.94)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M254.707,84.75V80.81c0-1.114-.774-1.684-2.02-1.684s-2.071.583-2.071,1.684V84.75H249.4V75.524h1.212v3.55a3.414,3.414,0,0,1,2.324-.777c1.869,0,2.979.92,2.979,2.358V84.75Z"
                        transform="translate(1137.968 821.94)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M263.485,83c0,1.4.858,2.2,2.441,2.2a3.143,3.143,0,0,0,2.172-.726l.825.557a4.39,4.39,0,0,1-3.03.985c-2.19,0-3.621-1.011-3.621-3.266a3.069,3.069,0,0,1,3.4-3.265c2.139,0,3.4,1.192,3.4,3.084V83Zm4.126-1.762a2.19,2.19,0,0,0-4.126,1.063h4.378a2.171,2.171,0,0,0-.252-1.063"
                        transform="translate(1134.108 820.753)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M280.973,85.938V82.012c0-1.127-.791-1.7-2.037-1.7s-2.055.583-2.055,1.7v3.926H275.67V79.563h1.212v.7a3.959,3.959,0,0,1,4.445-.181,2.086,2.086,0,0,1,.858,1.775v4.081Z"
                        transform="translate(1130.09 820.752)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M291.66,88.866a4.289,4.289,0,0,1-2.811-.856l.791-.6a2.963,2.963,0,0,0,1.987.635c1.6,0,2.272-.868,2.272-1.957v-1a3.048,3.048,0,0,1-2.324.829,3.373,3.373,0,0,1-2-.57,4,4,0,0,1,0-5.313,3.431,3.431,0,0,1,2.02-.557,2.978,2.978,0,0,1,2.324.83v-.752h1.2v6.57c0,1.58-1.279,2.734-3.451,2.734m.186-8.552c-1.8,0-2.071,1.192-2.071,2.384s.27,2.384,2.071,2.384S293.9,83.89,293.9,82.7s-.253-2.384-2.054-2.384"
                        transform="translate(1126.223 820.753)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M307.551,84.75V80.81c0-1.114-.774-1.684-2.02-1.684s-2.071.583-2.071,1.684V84.75h-1.212V75.524h1.212v3.55a3.414,3.414,0,0,1,2.324-.777c1.868,0,2.979.92,2.979,2.358V84.75Z"
                        transform="translate(1122.119 821.94)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M316.328,83c0,1.4.859,2.2,2.442,2.2a3.14,3.14,0,0,0,2.172-.726l.825.557a4.388,4.388,0,0,1-3.03.985c-2.189,0-3.62-1.011-3.62-3.266a3.069,3.069,0,0,1,3.4-3.265c2.138,0,3.4,1.192,3.4,3.084V83Zm4.126-1.762a2.19,2.19,0,0,0-4.126,1.063h4.378a2.156,2.156,0,0,0-.252-1.063"
                        transform="translate(1118.26 820.753)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M336.1,76.4v3.4h5.253v.881H336.1V84.75h-1.28V75.524h7.442V76.4Z"
                        transform="translate(1112.352 821.94)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M352.672,85.289a4.244,4.244,0,0,1-4.748,0,3.7,3.7,0,0,1,0-5.079,4.244,4.244,0,0,1,4.748,0,3.7,3.7,0,0,1,0,5.079m-.859-4.509a2.489,2.489,0,0,0-1.515-.466,2.441,2.441,0,0,0-1.5.466,3.217,3.217,0,0,0,0,3.939,2.441,2.441,0,0,0,1.5.466,2.49,2.49,0,0,0,1.515-.466,3.285,3.285,0,0,0,0-3.939"
                        transform="translate(1108.723 820.753)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M365.42,85.289a4.244,4.244,0,0,1-4.748,0,3.7,3.7,0,0,1,0-5.079,4.244,4.244,0,0,1,4.748,0,3.7,3.7,0,0,1,0,5.079m-.859-4.509a2.49,2.49,0,0,0-1.515-.466,2.44,2.44,0,0,0-1.5.466,3.217,3.217,0,0,0,0,3.939,2.441,2.441,0,0,0,1.5.466,2.49,2.49,0,0,0,1.515-.466,3.285,3.285,0,0,0,0-3.939"
                        transform="translate(1104.9 820.753)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M377.8,84.749v-.764a3.06,3.06,0,0,1-2.357.842,3.431,3.431,0,0,1-2.02-.557,4.135,4.135,0,0,1,0-5.417,3.431,3.431,0,0,1,2.02-.557,3.051,3.051,0,0,1,2.34.817v-3.59h1.213v9.226Zm-2.088-5.624c-1.8,0-2.087,1.192-2.087,2.436S373.909,84,375.71,84s2.071-1.192,2.071-2.436-.27-2.436-2.071-2.436"
                        transform="translate(1101.076 821.941)"
                        fill="#2e3a47"
                      />
                    </g>
                  </svg>
                </a>
                <ul className="col-12 col-lg-10 navbar-nav navbar__nav-footer">
                  {/* 關於我們 */}
                  <li className="nav-item nav__item-footer dropdown">
                    <a className="nav__link-footer show" href="javascript:void(0)">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="31.22"
                        height="31.22"
                        viewBox="0 0 31.22 31.22"
                      >
                        <defs>
                          <clipPath id="a">
                            <rect width="31.22" height="31.22" fill="#223746" />
                          </clipPath>
                        </defs>
                        <g transform="translate(0 0)">
                          <g transform="translate(0 0)" clipPath="url(#a)">
                            <path
                              d="M15.61,0A15.61,15.61,0,1,0,31.22,15.61,15.611,15.611,0,0,0,15.61,0m8.213,24.019a.617.617,0,0,1-.617.617H8.014a.617.617,0,0,1-.617-.617V15.79H23.823Zm.826-9.778H6.571a.617.617,0,0,1-.464-1.022l7.362-8.438a2.842,2.842,0,0,1,4.281,0l7.362,8.438a.616.616,0,0,1-.464,1.022"
                              transform="translate(0 0)"
                              fill="#223746"
                            />
                          </g>
                        </g>
                      </svg>
                      關於我們
                    </a>
                    <ul className="dropdown-menu nav__dropdown-menu-footer row col-10 col-lg-9">
                      <li className="dropdown-item nav__dropdown-item-footer col-6 col-lg-12">
                        <a className="nav__dropdown-item-link-footer" href="/">
                          正和私食
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item-footer col-6 col-lg-12">
                        <a className="nav__dropdown-item-link-footer" href="/johns">
                          元鍋JOHN's
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item-footer col-6 col-lg-12">
                        <a className="nav__dropdown-item-link-footer" href="/mmm">
                          MMM by Paul Lee
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item-footer col-6 col-lg-12">
                        <a
                          className="nav__dropdown-item-link-footer"
                          // 正式網址
                          href="/event/zhfood/purchaseprocess"
                          // 測試網址
                          // href="/purchase-process"
                        >
                          購物流程
                        </a>
                      </li>
                    </ul>
                  </li>
                  {/* 會員權益 */}
                  <li className="nav-item nav__item-footer dropdown">
                    <a className="nav__link-footer" href="javascript:void(0)">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="31.223"
                        height="31.223"
                        viewBox="0 0 31.223 31.223"
                      >
                        <path
                          d="M508.912,395.812a15.611,15.611,0,1,0,15.612,15.611,15.611,15.611,0,0,0-15.612-15.611m0,3.808a4.447,4.447,0,1,1-4.447,4.447,4.447,4.447,0,0,1,4.447-4.447M515,420.45h-12.17a2.165,2.165,0,0,1-2.166-2.165,8.25,8.25,0,1,1,16.5,0A2.164,2.164,0,0,1,515,420.45"
                          transform="translate(-493.301 -395.812)"
                          fill="#223746"
                        />
                      </svg>
                      會員權益
                    </a>
                    <ul className="dropdown-menu nav__dropdown-menu-footer row col-10 col-lg-9">
                      <li className="dropdown-item nav__dropdown-item-footer col-6 col-lg-12">
                        <a
                          className="nav__dropdown-item-link-footer"
                          // 正式網址
                          href="/event/zhfood/priv"
                          // 測試網址
                          // href="/pages/priv"
                        >
                          會員隱私權政策
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item-footer col-6 col-lg-12">
                        <a
                          className="nav__dropdown-item-link-footer"
                          // 正式網址
                          href="/event/zhfood/memRule"
                          // 測試網址
                          // href="/pages/memRule"
                        >
                          網站服務條款
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item-footer col-6 col-lg-12">
                        <a
                          className="nav__dropdown-item-link-footer"
                          // 正式網址
                          href="/event/zhfood/right"
                          // 測試網址
                          // href="/pages/right"
                        >
                          網路購物權益
                        </a>
                      </li>
                    </ul>
                  </li>
                  {/* 會員服務 */}
                  <li className="nav-item nav__item-footer dropdown">
                    <a className="nav__link-footer" href="javascript:void(0)">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="31.22"
                        height="31.22"
                        viewBox="0 0 31.22 31.22"
                      >
                        <defs>
                          <clipPath id="a">
                            <rect width="31.22" height="31.22" fill="#fff" />
                          </clipPath>
                        </defs>
                        <g clipPath="url(#a)">
                          <path
                            d="M19.007,15.264a1.014,1.014,0,0,0,.089.167.914.914,0,0,0,.124.151.987.987,0,0,0,1.391,0,.871.871,0,0,0,.124-.151.951.951,0,0,0,.089-.167,1.04,1.04,0,0,0,.055-.186.954.954,0,0,0,0-.383,1.04,1.04,0,0,0-.055-.186.969.969,0,0,0-.093-.17.724.724,0,0,0-.12-.147.958.958,0,0,0-.151-.124.913.913,0,0,0-.167-.089,1.884,1.884,0,0,0-.186-.058,1.079,1.079,0,0,0-.384,0,1.869,1.869,0,0,0-.185.058.914.914,0,0,0-.167.089,1.043,1.043,0,0,0-.275.272,1.011,1.011,0,0,0-.089.17,1.208,1.208,0,0,0-.055.186,1,1,0,0,0,0,.383,1.208,1.208,0,0,0,.055.186"
                            transform="translate(-2.227 -1.635)"
                            fill="#fff"
                          />
                          <path
                            d="M16.454,15.433a.972.972,0,0,0,.093-.167,1.04,1.04,0,0,0,.055-.186,1.071,1.071,0,0,0,.019-.193,1.056,1.056,0,0,0-.019-.19.825.825,0,0,0-.058-.186,1.011,1.011,0,0,0-.089-.17.865.865,0,0,0-.12-.147,1.017,1.017,0,0,0-1.391,0,.744.744,0,0,0-.124.147.95.95,0,0,0-.089.17.825.825,0,0,0-.058.186,1.056,1.056,0,0,0-.019.19,1.071,1.071,0,0,0,.019.193,1.039,1.039,0,0,0,.055.186,1.289,1.289,0,0,0,.093.167.958.958,0,0,0,.124.151,1.383,1.383,0,0,0,.146.124,1.163,1.163,0,0,0,.17.089,1.009,1.009,0,0,0,.183.054.976.976,0,0,0,.387,0,.98.98,0,0,0,.182-.054,1.128,1.128,0,0,0,.171-.089,1.2,1.2,0,0,0,.151-.124,1.17,1.17,0,0,0,.12-.151"
                            transform="translate(-1.724 -1.637)"
                            fill="#fff"
                          />
                          <path
                            d="M12.266,14.508a1.011,1.011,0,0,0-.089-.17.886.886,0,0,0-.124-.147.73.73,0,0,0-.146-.124.989.989,0,0,0-.171-.089,1.5,1.5,0,0,0-.185-.058,1.04,1.04,0,0,0-.384,0,1.294,1.294,0,0,0-.183.058.76.76,0,0,0-.17.089.906.906,0,0,0-.151.124.7.7,0,0,0-.12.147,1.036,1.036,0,0,0-.094.17,1.138,1.138,0,0,0-.054.186,1.064,1.064,0,0,0-.019.19.979.979,0,0,0,.984.985.826.826,0,0,0,.194-.02.917.917,0,0,0,.182-.054.817.817,0,0,0,.167-.089,1.149,1.149,0,0,0,.151-.124.926.926,0,0,0,.124-.152.979.979,0,0,0,.089-.167,1.151,1.151,0,0,0,.058-.185,1.075,1.075,0,0,0,.015-.194.77.77,0,0,0-.019-.19,1.138,1.138,0,0,0-.054-.186"
                            transform="translate(-1.22 -1.635)"
                            fill="#fff"
                          />
                          <path
                            d="M15.61,0A15.61,15.61,0,1,0,31.22,15.61,15.628,15.628,0,0,0,15.61,0M10.662,22.607a1.147,1.147,0,0,1-1.146-1.144V19.252H9.1a3.379,3.379,0,0,1-3.375-3.376v-5.25A3.379,3.379,0,0,1,9.1,7.25h9.629A3.379,3.379,0,0,1,22.1,10.625v5.25a3.379,3.379,0,0,1-3.376,3.376h-4.17L11.5,22.24a1.123,1.123,0,0,1-.834.367m14.835-2.9a2.581,2.581,0,0,1-2.581,2.581h-1v2.675a.475.475,0,0,1-.83.314L18,22.287H14.7a2.569,2.569,0,0,1-1.689-.633l1.806-1.763h3.91a4.02,4.02,0,0,0,4.016-4.016v-3.7h.173A2.581,2.581,0,0,1,25.5,14.754Z"
                            transform="translate(0 0)"
                            fill="#fff"
                          />
                        </g>
                      </svg>
                      會員服務
                    </a>
                    <ul className="dropdown-menu nav__dropdown-menu-footer row col-10 col-lg-9">
                      <li className="dropdown-item nav__dropdown-item-footer col-6 col-lg-12">
                        <a className="nav__dropdown-item-link-footer" href="/my-account/orders">
                          訂單查詢
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item-footer col-6 col-lg-12">
                        <a className="nav__dropdown-item-link-footer" href="/memberLogin">
                          會員登入
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item-footer col-6 col-lg-12">
                        <a
                          className="nav__dropdown-item-link-footer"
                          // 正式網址
                          href="/event/zhfood/membercard"
                          // 測試網址
                          // href="/member-card"
                        >
                          和樂家居會員條款
                        </a>
                      </li>
                    </ul>
                  </li>
                  {/* 網站客服信箱 */}
                  <li className="nav-item nav__item-footer dropdown">
                    <a className="nav__link-footer" href="/my-account/onlineContactform">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="31.223"
                        height="31.223"
                        viewBox="0 0 31.223 31.223"
                      >
                        <path
                          d="M508.912,395.812a15.611,15.611,0,1,0,15.612,15.611,15.611,15.611,0,0,0-15.612-15.611m0,3.808a4.447,4.447,0,1,1-4.447,4.447,4.447,4.447,0,0,1,4.447-4.447M515,420.45h-12.17a2.165,2.165,0,0,1-2.166-2.165,8.25,8.25,0,1,1,16.5,0A2.164,2.164,0,0,1,515,420.45"
                          transform="translate(-493.301 -395.812)"
                          fill="#223746"
                        />
                      </svg>
                      網站客服信箱
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <div className="text-center justify-content-center bg-secondary" id="copyright">
            <div className="row col-12 mx-auto footer__copyright-row">
              <div className="col col-12 col-md-8 text-lg-end pe-lg-0">
              版權所有 @copyright 2024  Zhenghe Food Co., Ltd. ‧ HOLA Furnishing CO., LTD. All Rights Reserved
              </div>
              <div className="col col-12 col-md-4 text-lg-start">
              和樂家居股份有限公司 統一編號:53096709         
              </div>
              <div>如您欲取消訂閱行銷訊息，請 <a href="https://www.zhfood.com/my-account/onlineContactform" style={{ textDecoration: 'underline' }} target="_blank">聯絡客服</a> 為您確認身分後再行取消</div>
            </div>
          </div>
          {/* ToTOP */}
          <a href="#main" className="d-block d-lg-none footer__button-to-top">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="45.707"
              height="45.707"
              viewBox="0 0 45.707 45.707"
            >
              <defs>
                <filter
                  id="a"
                  x="0"
                  y="0"
                  width="45.707"
                  height="45.707"
                  filterUnits="userSpaceOnUse"
                >
                  <feOffset dx="1" dy="1" input="SourceAlpha" />
                  <feGaussianBlur stdDeviation="1" result="b" />
                  <feFlood floodOpacity="0.098" />
                  <feComposite operator="in" in2="b" />
                  <feComposite in="SourceGraphic" />
                </filter>
              </defs>
              <g transform="translate(-380.876 -5454)">
                <g transform="translate(382.876 5456)">
                  <g transform="matrix(1, 0, 0, 1, -2, -2)">
                    <path
                      d="M0,19.853A19.854,19.854,0,1,1,19.854,39.707,19.853,19.853,0,0,1,0,19.853Z"
                      transform="translate(2 2)"
                      fill="#d9ced0"
                    />
                  </g>
                </g>
                <path d="M9,0l9,12H0Z" transform="translate(393.583 5468.583)" fill="#fff" />
              </g>
            </svg>
          </a>
        </footer>
      </>
    );
  }
}

export default FooterContainer;
